module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/evaluate/assets/arrow-right.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/evaluate/assets/arrow-right.png
// module id = 562
// module chunks = 418